import classNames from 'classnames';
import * as React from 'react';
import MerchantCategory from '../../../../domain/entities/MerchantCategory';
import css from './GlobalFooter.module.scss';
import ServiceFooter from './ServiceFooter';
import SiteFooter from './SiteFooter';

export interface Props {
  categories?: MerchantCategory[];
  withServiceFooter?: boolean;
  isMerchantStickyFooterExist: boolean;
}

class GlobalFooter extends React.PureComponent<Props & React.HTMLProps<{}>> {
  public static defaultProps: Props = {
    categories: [],
    withServiceFooter: true,
    isMerchantStickyFooterExist: false,
  };

  public render() {
    const {
      categories,
      withServiceFooter,
      isMerchantStickyFooterExist,
    } = this.props;

    const baseClasses = classNames(css.GlobalFooter, {
      [css.StickyFooterPadding]: isMerchantStickyFooterExist,
    });

    return (
      <footer className={baseClasses}>
        {categories && categories.length > 0 && withServiceFooter && (
          <ServiceFooter categories={categories} />
        )}
        <SiteFooter />
      </footer>
    );
  }
}

export default GlobalFooter;
